var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-modal',{attrs:{"height":"600","show":_vm.show},on:{"close":_vm.close}},[_c('social-media-header',{attrs:{"slot":"header"},slot:"header"}),_c('social-media',{attrs:{"child-id":_vm.fromBus.childId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }